import { Card, Flex, Text } from "@radix-ui/themes"
import { LucideIcon } from "lucide-react"

interface StatsCardProps {
  label: string
  count: number
  icon: LucideIcon
  href?: string
  iconColor?: string
}

export default function StatsCard({
  label,
  count,
  icon: Icon,
  href,
  iconColor = "var(--accent-9)",
}: StatsCardProps) {
  const content = (
    <Card>
      <Flex direction="column" gap="3">
        <Flex align="center" gap="2" style={{ color: iconColor }}>
          <Icon size={20} />
          <Text size="3" color="gray">
            {label}
          </Text>
        </Flex>
        <Text size="7" weight="bold" style={{ color: iconColor }}>
          {count}
        </Text>
      </Flex>
    </Card>
  )

  if (href) {
    return (
      <a
        href={href}
        style={{ textDecoration: "none", cursor: "pointer" }}
        className="hover:opacity-80 transition-opacity"
      >
        {content}
      </a>
    )
  }

  return content
}
